export default __webpack_public_path__ + "static/media/thankyou.28ad43c7.jpg";